'use strict';

const headerMenu = require('./header-menu');
const flyout = require('./flyout');
const loginOverlay = require('./loginOverlay');
const isMobileWidth = require('./modules/util/isMobileWidth');
const gwpWelcomeMessage = require('./gwp-welcome-message');
const pgminicart = require('./pages/personalisedgifting/pgminicart');
const damHelper = require('./dam/dam-helper');
const ajaxUrl = require('./modules/util/ajaxUrl');
const isDesktopView = require('./modules/helpers/_helpers');

const timer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

function displayCRMChoiceModule(discountDataElement, miniCart, openMinicart) {
    const isCartPage = !!$('.js-cart-page-wrapper').length;
    const bonusProductsView = require('./bonus-products-view');
    const url = discountDataElement.data('choice-discount-url');
    const productID = discountDataElement.data('choice-selected-product').toString();
    bonusProductsView.show({
        url: url,
        giftChange: true,
        response: true,
        selectedID: productID,
        onClose: function () {
            if (isMobileWidth()) {
                $.ajax({
                    type: 'GET',
                    url: ajaxUrl(Urls.showPromotionsPopup),
                    success: function (response) {
                        if (!response) {
                            return;
                        }
                        miniCart.showMobileCrmToast(response);
                    }
                });
            } else if (!isCartPage) {
                openMinicart();
            }
        }
    });
}

const minicart = {
    isInitialized: false,
    init: function () {
        if (this.isInitialized) {
            return;
        }
        pgminicart.init(this);

        loginOverlay.init();
        const thisMinicart = this;
        this.$el = $('.js-minicart-flyout');

        const openMinicart = function () {
            const orderSummary = $('.order-confirmation-summary');

            if (orderSummary.length && isDesktopView) {
                window.location.href = Urls.cartShow;
            }

            thisMinicart.show();
            timer.clear();
            $('.js-open-minicart').addClass('js-flyout-opened');

            damHelper.updateImages($('.js-minicart-flyout'));

            if ($('.js-gwp-welcome-banner').length) {
                $('.js-gwp-welcome-banner').addClass('visible');
            }
        };

        $(document).off('click', '.js-open-minicart');
        $(document).on('click', '.js-open-minicart', function (e) {
            if (!isMobileWidth()) {
                e.preventDefault();
                openMinicart();
            }
        });

        this.isInitialized = true;

        const cartPromotionWrapper = $('.js-gwp-shoppingcart-wrapper');
        const minicartPromotionsWrapper = $('.js-gwp-minicart-wrapper');
        if (
            (!!minicartPromotionsWrapper.length && minicartPromotionsWrapper.first().hasClass('js-just-logged-in')) ||
            (!!cartPromotionWrapper.length && cartPromotionWrapper.first().hasClass('js-is-incremented'))
        ) {
            const hasPromotions = minicartPromotionsWrapper.hasClass('js-has-promotions');
            const isCartPage = !!$('.js-cart-page-wrapper').length;
            const isAccountPage = !!$('.js-go-to-overview').length;
            if ((hasPromotions && !isAccountPage) || isCartPage) {
                let discountDataElement = $('.js-incremented-product-data');
                if ($('.js-minicart-discount-data').length) {
                    discountDataElement = $('.js-minicart-discount-data').first();
                }
                if (discountDataElement.length) {
                    displayCRMChoiceModule(discountDataElement, thisMinicart, openMinicart);
                } else {
                    if (isMobileWidth()) {
                        $.ajax({
                            type: 'GET',
                            url: ajaxUrl(Urls.showPromotionsPopup),
                            success: function (response) {
                                if (!response) {
                                    return;
                                }
                                thisMinicart.showMobileCrmToast(response);
                            }
                        });
                    } else {
                        openMinicart();
                    }
                }
            }
        }

        if (!isMobileWidth()) {
            const gwpWelcomeBanner = $('.js-minicart-flyout-inner-content .js-gwp-welcome-banner');
            const shouldDisplayMinicart = gwpWelcomeBanner.length > 0 && !gwpWelcomeBanner.hasClass('hide');

            if (shouldDisplayMinicart) {
                openMinicart();
                thisMinicart.scrollToGwp();
                thisMinicart.animateGwpWelcomeMessage();
            }
        }

        // Show minicart if cart was merged.
        const $mergedAlert = $('.js-cart-merged');

        if ($mergedAlert.length > 0) {
            openMinicart();
        }
    },
    scrollToGwp: function () {
        const minicartWrapper = $('.gwp-minicart-wrapper');
        if (minicartWrapper.length === 0) {
            return;
        }

        const top = minicartWrapper.offset().top;
        $('.js-flyout-section').scrollTop(top);
    },
    animateGwpWelcomeMessage: function () {
        gwpWelcomeMessage.init({
            $parentElement: $('.js-minicart-flyout-inner-content')
        });

        gwpWelcomeMessage.animate();
    },
    updateApproachingDiscounts: function () {
        $.ajax({
            url: Urls.getApproachingDiscounts,
            type: 'GET'
        })
            .done(function (response) {
                $('.js-approaching-discount').html(response);
            })
            .fail(function () {
                window.alert(Resources.BAD_RESPONSE);
            });
    },
    updateProductsAndPrice: function (totalPrice, numberOfProducts, numberOfGifts) {
        $('.js-total-price').text(totalPrice);

        let overviewText = '';
        const $selectedProductsText = $('.js-selected-products');

        const fmtProducts =
            numberOfProducts > 1
                ? $selectedProductsText.data('text-format-multiple-products')
                : $selectedProductsText.data('text-format-one-product');
        const fmtGifts =
            numberOfGifts > 1
                ? $selectedProductsText.data('text-format-multiple-gifts')
                : $selectedProductsText.data('text-format-one-gift');
        const msgProducts = String.format(fmtProducts, numberOfProducts);
        const msgGifts = String.format(fmtGifts, numberOfGifts);

        if (numberOfGifts > 0) {
            overviewText = String.format($selectedProductsText.data('text-format-full-message'), msgProducts, msgGifts);
        } else {
            overviewText = msgProducts;
        }

        $selectedProductsText.text(overviewText);
    },
    updateSelectedGifts: function (currentPromotionId) {
        const slideDuration = 2000;
        let slideLeftDelay = 0;
        const $unselectedPromotions = $('.js-bonus-product.unselected');
        const $selectedPromotions = $('.js-bonus-product:not(.unselected)');

        $selectedPromotions.each(function () {
            const $this = $(this);
            const promotionId = $this.data('promotion-id');

            if (promotionId !== currentPromotionId) {
                slideLeftDelay = slideDuration;

                $this.animate({right: '-150%'}, slideDuration, function () {
                    $this.remove();
                });
            }
        });

        $unselectedPromotions.each(function () {
            const $this = $(this);
            const promotionId = $(this).data('promotion-id');

            if (promotionId === currentPromotionId) {
                setTimeout(function () {
                    $this.removeClass('unselected');
                    $this.css('left', '150%');

                    $this.animate({left: 0}, slideDuration);
                }, slideLeftDelay);
            }
        });
    },
    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function (html, activateTimer) {
        // show the flyout minicart
        this.$el.html(html);
        this.init();

        if (activateTimer) {
            timer.clear();
        }

        flyout.open({
            flyoutType: 'minicart'
        });

        if (activateTimer && !$('.js-gwp-open').length && !$('.checkout-flyout-inner-content').length) {
            // after a time out automatically close it
            timer.start(4000, this.close.bind(this));
        }

        const subtotalBlock = $('.js-minicart-flyout-checkout');
        $('.js-minicart-flyout-inner-content').css('padding-bottom', subtotalBlock.outerHeight());
    },
    /**
     * Updates the minicart without showing it.
     */
    update: function (html) {
        this.$el.html(html);
        this.init();
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide: function () {
        timer.clear();

        // after a time out automatically close it
        timer.start(4000, this.close.bind(this));
        //prevent body scroll
        headerMenu.tools.preventBodyScroll(true);

        // add empty header
        $('.js-header').addClass('header--empty');
    },
    /**
     * @function
     * @description Switch to empty cart view.
     */
    switchToEmptyCart: function () {
        $('.js-minicart-empty').removeClass('hide');
        $('.js-minicart-not-empty').addClass('hide');
        $('.js-selected-products').hide();
    },
    /**
     * @function
     * @description Closes the mini cart with given delay
     * @param {Number} delay The delay in milliseconds
     */
    close: function () {
        if (!$('.js-gwp-open').length) {
            timer.clear();
            flyout.closeFlyouts();
        }
    },
    /**
     * @function
     * @description This triggeres the new CRM 2.0 toast for mobile
     *
     * Ticket: https://rituals.atlassian.net/browse/DL-22421
     */
    showMobileCrmToast: function (html) {
        // Remove elements we do not use
        $('.image-holder, .text-holder', html).remove();

        // Inject new HTML at end of toast el and show the toast with a delay
        // of 500ms
        timer.start(500, function () {
            //remove existing crm toast
            $('.js-mobile-crm-toast').remove();
            $('.js-cart-confirm-mobile').append(html);
            $('.js-cart-confirm-mobile').addClass('mobile-crm-toast-wrapper').addClass('open');
            damHelper.updateImages($('.js-cart-confirm-mobile'));
            $('.js-cart-confirmation-wrapper').attr('tabindex', '0');
            $('.js-modal-overlay').fadeIn();
            $('.js-minicart-flyout-spinner').find('button[type="submit"]').on('click', function(){
                $(this).addClass('hide');
                $('.js-spinner-general.spinner-custom-mobile').addClass('show');

                const spinner = $('.js-spinner-general.spinner-custom-mobile span');
                spinner.css('animation-play-state', 'paused');

                //restart animation iOS fix
                setTimeout(function() {
                    spinner.css('animation-play-state', 'running');
                }, 5);
            });
        });
    },
    /**
     * @function
     * @description To prevent the element visibilty while the page is loading we
     * initially set the opacity 0. We set it to 1 by adding this class on page
     * load.
     *
     * Ticket: https://rituals.atlassian.net/browse/DL-9378
     */
    initMobileConfirmation: function () {
        $('.js-cart-confirm-mobile').addClass('page-loaded');
    },
    /**
     * @function
     * @description When adding to cart on mobile, instead of the minicart a
     * confirmation flyout appears
     */
    mobileConfirmation: function (html) {
        this.$el.html(html);
        this.init();
        timer.start(500, function () {
            $('.js-cart-confirm-mobile').addClass('open');
            damHelper.updateImages($('.js-cart-confirm-mobile'));
            $('.js-cart-confirmation-wrapper').attr('tabindex', '0');
            $('.js-modal-overlay').fadeIn();
        });
        timer.start(4500, minicart.hideMobileConfirmation);
    },
    hideMobileConfirmation: function () {
        $('.js-cart-confirm-mobile').removeClass('open');
        $('.js-cart-confirmation-wrapper').attr('tabindex', '-1');
        $('.js-modal-overlay').fadeOut();
    },
    updateHeaderCartIcon: function (numberOfProducts) {
        // update the quantity in the cart icon circle
        if (!numberOfProducts) {
            $('.js-shopping-circle').text('');
        } else {
            $('.js-shopping-circle').text(numberOfProducts);
        }
    },
    adjustPricePadding: function () {
        $('.js-minicart-product').each(function () {
            const $this = $(this);
            const smallTitle = '.js-mini-cart-small-title';
            const $price = $this.find('.js-mini-cart-price-wrapper');

            if ($this.find(smallTitle).length) {
                const smallTitleHeight = $(smallTitle).outerHeight() + 5;

                $price.css('padding-top', smallTitleHeight);
            } else {
                $price.css('padding-top', 0);
            }
        });
    }
};

module.exports = minicart;
